import React from 'react';
import SEOHead from '../../components/seo/SEOHead';
import { motion } from 'framer-motion';

const PrivacyPolicy = () => {
  return (
    <>
      <SEOHead
        title="Privacy Policy"
        description="Learn about how we collect, use, and protect your personal information at Animatronic Database."
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-3xl font-bold text-content-primary mb-8">Privacy Policy</h1>
          
          <div className="prose prose-invert max-w-none space-y-6">
            <p className="text-content-secondary">Effective Date: 01/13/2025 </p>
            Big Leaf LLC (DBA "Animatronic Database") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal information when you visit our website or interact with our services.
            <section>
              <h2>1. Information We Collect</h2>
              <p>
                We collect the following types of personal information:
              </p>
              <ul>
                <li>Account Information: When you create an account using Auth0 for authentication, we collect your name, email address, and any other information you voluntarily provide.</li>
                <li>User-Generated Content: Information and content you submit, such as comments, votes on animatronics, and images or descriptions of animatronics.</li>
                <li>Analytics Data: Information collected via Netlify metrics, including IP addresses, browser type, pages visited, and site traffic.</li>
                <li>Cookies: See the Cookie Policy below for details on cookies and tracking technologies.</li>
              </ul>
            </section>

            <section>
              <h2>2. How We Use Your Information</h2>
              <p>We use your information to:</p>
              <ul>
                <li>Manage your account and provide login functionality.</li>
                <li>Facilitate commenting, voting, and submissions.</li>
                <li>Improve site functionality and user experience.</li>
                <li>Communicate with you about updates, services, or support.</li>
                <li>Display ads, sponsorships, or affiliate links.</li>
              </ul>
            </section>

            <section>
              <h2>3. Sharing Your Information</h2>
              <p>
                We do not sell your personal data. We may share your information:
              </p>
              <ul>
                <li>With service providers (e.g., Auth0, Netlify) for website functionality.</li>
                <li>To comply with legal obligations or protect our rights.</li>
                <li>With your consent, for sponsorships or other opportunities.</li>
              </ul>
            </section>

            <section>
              <h2>4. Your Rights</h2>
              <p>You have the right to:</p>
              <ul>
                <li>Access and Correction: You can request to access or correct your personal data.</li>
                <li>Data Deletion: You can request that we delete your data.</li>
                <li>Opt-Out of Tracking: See the Cookie Policy for managing cookies and analytics preferences.</li>
              </ul>
            </section>

            <section>
              <h2>5. Contact Us</h2>
              <p>
                For privacy-related concerns, email us at {' '}
                <a href="mailto:legal@animatronicdatabase.com" className="text-brand hover:text-brand-light">
                  legal@animatronicdatabase.com
                </a>
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default PrivacyPolicy;